// kartenKurzfassung.ts — was eine eingeklappte Karte der Kontaktanlage in
// ihrem Kopf zeigt. Kurz genug für eine Zeile; leer heißt: nichts zeigen.

const t = (v: unknown): string => String(v ?? "").trim();

export function anschriftKurz(street: unknown, plz: unknown, city: unknown, weitere: number): string {
  const ort = [t(plz), t(city)].filter(Boolean).join(" ");
  const basis = [t(street), ort].filter(Boolean).join(", ");
  if (!basis) return "";
  return weitere > 0 ? `${basis} · +${weitere} weitere` : basis;
}

export function ibanKurz(iban: unknown): string {
  const kompakt = t(iban).replace(/\s+/g, "");
  if (kompakt.length <= 8) return kompakt;
  return `${kompakt.slice(0, 4)} … ${kompakt.slice(-4)}`;
}

export function bankKurz(iban: unknown, bankname: unknown, weitere: number): string {
  if (!t(iban)) return "";
  if (weitere > 0) return `${weitere + 1} Konten`;
  return [ibanKurz(iban), t(bankname)].filter(Boolean).join(" · ");
}

export function kommunikationKurz(nummern: unknown[], mails: unknown[]): string {
  const nummer = nummern.map(t).find(Boolean) ?? "";
  const mail = mails.map(t).find(Boolean) ?? "";
  return [nummer, mail].filter(Boolean).join(" · ");
}

export function anzahlKurz(n: number, einzahl: string, mehrzahl: string): string {
  if (n <= 0) return "";
  return `${n} ${n === 1 ? einzahl : mehrzahl}`;
}
